<template>
  <v-container class="pa-16">
    <v-data-table :headers="headers" :items="timesheets" class="elevation-0" :options.sync="options"
      :server-items-length="total" :footer-props="{
        itemsPerPageOptions: [20, 30, 40, 50],
        showFirstLastPage: true,
        itemsPerPageText: 'Lignes par page :',
      }" :header-props="{ sortIcon: null }" no-data-text="" no-results-text="">
      <template v-slot:body.prepend v-if="loader">
        <tr v-for="n in 5" :key="'skeleton-' + n">
          <td :colspan="headers.length + 1">
            <v-skeleton-loader type="table-row" class="mx-5 my-2" />
          </td>
        </tr>
      </template>
      <template v-slot:no-data v-if="!loader">
        Aucun rapport
      </template>
      <template v-slot:item.start_date="{ item }">
        {{ item.start_date | moment("dddd DD/MM/YYYY") }}
      </template>
      <template v-slot:top>
        <v-toolbar flat>
          <v-toolbar-title id="toolbar-title">Tableau de bord</v-toolbar-title>
          <v-spacer></v-spacer>
        </v-toolbar>
      </template>
    </v-data-table>
  </v-container>
</template>
<script>
import { listTimeSheetsByDate } from "@/services/statistics.api";

export default {
  data: () => ({
    total: 0,
    options: {},
    editedItem: {},
    headers: [
      {
        text: "Date",
        align: "start",
        sortable: true,
        value: "start_date"
      },
      { text: "Nb rapports remplis", value: "completed", align: "center" },
      { text: "Nb rapports manquants", value: "incompleted", align: "center" }
      // { text: "Actions", value: "actions", sortable: false }
    ],
    timesheets: [],
    pageNumber: 1,
    last_page: 0,
    loader: false,
  }),

  watch: {
    options: {
      handler() {
        this.loader = true;
        this.editedItem.order_by = this.options.sortBy[0];
        this.editedItem.order_by_direction = this.options.sortDesc[0];
        this.timesheets = [];
        this.pageNumber = this.options.page;
        const perPage = this.options.itemsPerPage || 20;
        listTimeSheetsByDate(this.pageNumber, perPage, this.editedItem).then(
          response => {
            this.timesheets = response.data.data;
            this.last_page = response.data.last_page;
            this.total = response.data.total;
            this.loader = false;
          }
        );
      },
      deep: true
    },
  },
  created() {
    this.initialize();
  },
  methods: {
    getAllTimeSheetsByDate() {
      this.editedItem.order_by = this.options.sortBy[0];
      this.editedItem.order_by_direction = this.options.sortDesc[0];
      this.timesheets = [];
      this.pageNumber = this.options.page;
      const perPage = this.options.itemsPerPage || 20;
      this.loader = true;
      listTimeSheetsByDate(this.pageNumber, perPage, this.editedItem).then(response => {
        this.timesheets = response.data.data;
        this.last_page = response.data.last_page;
      }).finally(() => {
        this.loader = false;
      });
    },
    initialize() {
      this.getAllTimeSheetsByDate();
    }
  }
};
</script>
